import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import i18n from 'i18next';

import ModalActions from '~redux/Modal/actions';
import { MODALS } from '~redux/Modal/constants';
import { KINDS, MESSAGES_TYPES } from '~app/screens/Commerce/components/TopSiteMessage/constants';

import { hasFutureActiveOrder } from './utils';

const useCheckScheduledOrder = () => {
  const dispatch = useDispatch();
  const activeOrders = useSelector((state) => state.order.activeOrders);

  useEffect(() => {
    if (hasFutureActiveOrder(activeOrders)) {
      dispatch(
        ModalActions.openModalWithData(MODALS.TOP_SITE_MESSAGE, {
          message: i18n.t('TopSiteMessage:scheduledOrder'),
          kind: KINDS.WARNING,
          name: MESSAGES_TYPES.scheduledOrder
        })
      );
    }
  }, [dispatch, activeOrders]);
};

export default useCheckScheduledOrder;
